var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 1c1.964 0 3.707.945 4.8 2.4a1 1 0 0 1-1.6 1.2A4 4 0 0 0 8 7v3h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2V7a6 6 0 0 1 6-6zm8 11H4v8h16z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }